import { useEffect, useState } from 'react'
import { FiInfo } from 'react-icons/fi'
import Btn from '../Btn'
import CheckBoxGroup from './components/CheckBoxGroup'
import ComboBox from './components/ComboBox'
import TextField from './components/TextField'
import { InputObject, FormProps } from './components/types'

const inputs: InputObject = {
    "textfield": (props: any) => <TextField {...props} />,
    "textarea": (props: any) => <textarea {...props}></textarea>,
    "button": (props: any) => <input />,
    "checkbox": (props: any) => <CheckBoxGroup {...props} />,
    "checkboxgroup": (props: any) => <input />,
    "combobox": (props: any) => <ComboBox {...props} />,
    "date": (props: any) => <input />,
    'datetime-local': (props: any) => <input />,
    "file": (props: any) => <input />,
    "radio": (props: any) => <input />,
    "range": (props: any) => <input />,
    "time": (props: any) => <input />,
    "url": (props: any) => <input />
}

const Form = ({ fields, ...props }: FormProps) => {
    const [_fields, setFields] = useState<JSX.Element[]>([])
    useEffect(() => {
        const htmlFields = [];
        for (const field of fields) {
            const El = inputs[field.type]
            htmlFields.push(
                <div title={field.props.inputPlaceholder ?? ''} className="flex gap-2 flex-col w-full">
                    {
                        field.showTitle &&
                        <span className='text-gray-400 block pl-14'>
                            {field.props.inputPlaceholder}
                        </span>
                    }
                    <El {...field.props} />
                    {
                        field.info &&
                        <span className='self-end flex items-center gap-2 mr-8 text-sm'>
                            <FiInfo fill='black' stroke='white' size={24} />
                            <span className="text-gray-400">{field.info}</span>
                        </span>
                    }
                </div>
            )
        }
        setFields(htmlFields);
    }, [fields, setFields])
    return (
        <form className="w-full flex flex-col items-center gap-6">
            {_fields}
            <div id="form-action-buttons" className='flex justify-center items-center w-full gap-2'>
                <Btn defaultStyle noHoverEffect
                    className='flex-grow max-w-xs'
                    onClick={props.onBack}
                >
                    BACK
                </Btn>
                <Btn filled defaultStyle noHoverEffect
                    className='flex-grow max-w-xs'
                    onClick={props.onNext}
                >
                    NEXT
                </Btn>
            </div>
        </form>
    )
}

export default Form